import { isObject, isString } from '../utils';
export class HttpException extends Error {
    constructor(response, status) {
        super();
        this.response = response;
        this.status = status;
        this.message = response;
    }
    getResponse() {
        return this.response;
    }
    getStatus() {
        return this.status;
    }
    toString() {
        const message = this.getErrorString(this.message);
        return `Error: ${message}`;
    }
    getErrorString(target) {
        return isString(target) ? target : JSON.stringify(target);
    }
    static createBody(message, error, statusCode) {
        if (!message) {
            return { statusCode, error };
        }
        return isObject(message) && !Array.isArray(message) ? message : { statusCode, error, message };
    }
}
//# sourceMappingURL=http.exception.js.map